export default __webpack_public_path__ + "static/media/goshen107.9bdddf4c.jpg";